import { Observable } from 'rxjs/Rx'

import { ModelRepository } from '../../../model-repository'
import { ModelRepositoryAdapter } from '../../../model-repository/model-repository-adapter'
import { TestExecutionRecord, TestExecution } from '../../models'

export class TestExecutionRecordService extends ModelRepositoryAdapter<TestExecutionRecord> {
  public constructor(_modelRepository: ModelRepository) {
    super(_modelRepository, TestExecutionRecord)
  }

  public findRecordByExecution(testExecution: TestExecution): Observable<TestExecutionRecord> {
    return this.findModelsBy(
      { testExecution: testExecution },
      ['test-execution']
    ).map((results) => results[0])
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/test-execution-record/test-execution-record.service.ts